import FieldConfig from "../../../proto/field-config";
import FieldItemModelCalculatedExpenses_TableCell from "./render/table/table-cell";
import FieldCurrency from "../../../generic/finance/currency/currency";
import AggregateNumber from "../../../../fields/aggregate/aggregate-number";
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types";
import AggregateCost from "../../../../fields/system/cost/components/aggregate-cost";
import Task from "../../../../model2/task/task";
import Project from "../../../../model2/project/project";
import {SortDirection} from "../../../../data-structures/sort";
import ItemModel from "../../../../model2/item/item-model";


export default class FieldItemModelCalculatedExpenses extends FieldCurrency {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Expenses";
        this.label      = "Expenses";
        this.icon       = "i5-expenses-light"

        this.renderComponents.tableCell     = FieldItemModelCalculatedExpenses_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem:ItemModel) => {
                    return listItem.calculatedExpenses.total || 0
                }
            ],
            directions  : [sort]
        }
    }


    getAggregateValue(model:Task|Project) {
        return model.expensesCollection?.total
    }

    getAggregateClass() {
        return AggregateNumber
    }

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }

    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    get AggregateComponent() {
        return AggregateCost.bind(null, this.getAggregateOptions())
    }

}